import { formatCurrencyAmount } from '@/utils/format'
import { resolveSiteCurrency } from '@/utils/siteBrand'

export default {
  computed: {
    siteCurrency () {
      return resolveSiteCurrency(this.$store.state.siteInfo)
    }
  },
  methods: {
    formatCurrency (value) {
      return formatCurrencyAmount(value, this.siteCurrency)
    },
    formatBalance (value) {
      return formatCurrencyAmount(value, this.siteCurrency)
    }
  }
}
